export default __webpack_public_path__ + "static/media/5cha.e46c8515.svg";